import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
export default defineComponent({
    name: 'filter-reset-all',
    computed: Object.assign({}, mapGetters('blue', {
        availableFilters: 'availableFilters',
        appliedFilters: 'appliedFilters',
    })),
    methods: Object.assign({}, mapActions('blue', {
        resetAllFilters: 'RESET_FILTERS',
    })),
});
